import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../../MyComponents/Footer";
// import GuestNav from "../../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../../MyComponents/Hero2";
import FAQS from "../../../MyComponents/FooterPages/newfaq"
import heroContent from "../HeroContent-CDesign";
import leftimgs from "../../../assets/Appleftimg.png";
import rightimgs from "../../../assets/Apprightimg.png";
import CourseTimeline from "../../../MyComponents/CourseTimeline";
import Benefits from "../../../MyComponents/Benefits";
import FunActivities from "../../../MyComponents/FunActivities";
import BenefitsDataImg1 from "../../../assets/App-benefit-img1.png";
import BenefitsDataImg2 from "../../../assets/App-benefit-img2.png";
import BenefitsDataImg3 from "../../../assets/App-benefit-img3.png";
import BenefitsDataImg4 from "../../../assets/App-benefit-img4.png";
import BenefitsDataImg5 from "../../../assets/App-benefit-img5.png";
import BenefitsDataImg6 from "../../../assets/App-benefit-img6.png";
import BenefitsDataImg7 from "../../../assets/App-benefit-img7.png";
import BenefitsDataImg8 from "../../../assets/App-benefit-img8.png";
import BenefitsDataImg9 from "../../../assets/App-benefit-img9.png";
import FunactivitiesImg1 from "../../../assets/AppFun-img1.png";
import FunactivitiesImg2 from "../../../assets/AppFun-img2.png";
import FunactivitiesImg3 from "../../../assets/AppFun-img3.png";
import FunactivitiesImg4 from "../../../assets/AppFun-img4.png";
import FunactivitiesImg5 from "../../../assets/AppFun-img5.png";
import LearningStyle from "../../../MyComponents/LearningStyle"
import HeadSection from "../../HeadSection.js";
import pencilIcon from "../../../assets/pencil.png";

import Testimonials from "../../../MyComponents/Testimonials";
 const beginnerModules = [
    {
      title: "Module 1",
      activities: "09",
      classes: "05",
      description: " Fundamentals of App Development - Introduction to basic app development concepts, emulator setup, and creating simple apps with components.",
    },
    {
      title: "Module 2",
      activities: "09",
      classes: "05",
      description: " Single Screen Apps  Designing one-screen apps with various components and understanding the use of extensions in app creation.",
    },
    
    
  ];

  const advancedModules = [
    {
      title: "Module 1",
      activities: "09",
      classes: "05",
      description: "Multi Screen Apps-  Learning to build multi-screen apps, work with web views, variables, and linking different screens within an app.",
    },
    {
      title: "Module 2",
      activities: "09",
      classes: "05",
      description:" Gaming Apps-  Creating interactive gaming apps using logic, control blocks, and other essential components.",
    },
    {
      title: "Module 3",
      activities: "09",
      classes: "05",
      description:"Apps Using Database  Exploring databases, connecting apps to databases, uploading data, and understanding OTP (One Time Password).",
    },
   
  ];


  const benefitsData = [
      {
        title: "Learn App Architecture",
        description: "Understand app structure and optimize user experience",
        icon: "Polymath-images/App-benefit-img1.png"
      },
      {
        title: "Understand App Development",
        description: "Learn core concepts and steps in app creation. ",
        icon: "Polymath-images/App-benefit-img2.png",
      },
      {
        title: "Master Design Thinking",
        description: "Solve problems with creative, user-focused design. ",
        icon: "Polymath-images/App-benefit-img3.png",
      },
      {
        title: "Solve Real-World Problems",
        description: "Use technology to address challenges. Create practical, impactful solutions.",
        icon: "Polymath-images/App-benefit-img4.png",
      },
      {
        title: "Learn UI Design",
        description: "Design intuitive, user-friendly interfaces. Create engaging, functional digital experiences.",
        icon: "Polymath-images/App-benefit-img5.png",
      },
      {
        title: "Explore User Interaction",
        description: "Study user engagement and improve usability. ",
        icon: "Polymath-images/App-benefit-img6.png",
      },
      {
        title: "Build 21st-Century Skills",
        description: " Develop creativity, adaptability, and digital literacy.",
        icon: "Polymath-images/App-benefit-img7.png",
      },
      {
        title: "Boost Critical Thinking",
        description: "Strengthen problem-solving and decision-making.",
        icon: "Polymath-images/App-benefit-img8.png",
      },
      {
        title: "Spark Creativity",
        description: "Cultivate your innovative thinking and creativity. ",
        icon: "Polymath-images/App-benefit-img9.png",
      },
    ];
    const activitiesData = [
        {
          title: "FM Radio App",
          image: "Polymath-images/AppFun-img1.png",
        },
        {
          title: "Light Bulb App",
          image: "Polymath-images/AppFun-img2.png",
        },
        {
          title: "Walking Step App",
          image: "Polymath-images/AppFun-img3.png",
        },
        {
          title: "Animal Sound App",
          image: "Polymath-images/AppFun-img4.png",
        },
        {
          title: "Dictionary",
          image: "Polymath-images/AppFun-img5.png",
        },
      ];
     const videoData = {
    title: "Watch Our Introduction Video",
    description:
      "Discover how kids can turn their creativity into stunning designs! In this video, we’ll introduce fun tools, basic design tips, and exciting projects like logos, flyers, and digital art. Whether you're just starting out or love being creative, this is the perfect place to begin your design journey.",

      
    videoSrc: "", // Replace with the actual video URL
  };
const AppDevelopment = () => {
  const Apppage = heroContent.appsection;
  return (
    <>
       {/* <GuestNav/> */}
    <HeadSection
      leftImg={'Polymath-images/Appleftimg.png'}
      rightImg={'Polymath-images/Apprightimg.png'}
      titlePart1="App Development"
      titlePart2="Course"
      description="Polymath-Kids App Development Program for kids is a comprehensive course which enables them to develop and publish their own interesting and creative Apps. There are countless career opportunities for individuals proficient in app development essentials. Learning to code at an early age can help learners become experts and reap the benefits provided by technology."
      button1Text= {false}
      button2Text="Book Free Demo Class"
      button1Icon={'Polymath-images/pencil.png'}
      button2Icon={'Polymath-images/pencil.png'}
      onButton1Click={() => alert("Early bird discount clicked!")}
      onButton2Click={() => alert("Book demo clicked!")}
    />
       <CourseTimeline
              title1="Course Structure & Syllabus"
              title="Beginner Level Course"
              modules={beginnerModules}
            />
            <CourseTimeline
             
              title="Advance Level Course"
              modules={advancedModules}
            />
       <Benefits
        title="How Students Can Benefit From Abacus"
        benefitsData={benefitsData}
      />
       <FunActivities
              mainTitle="Learn Kidprenur Course"
              subTitle="With 40+ Fun Activities"
              activities={activitiesData}
            />
        <LearningStyle/>
         
      <Testimonials/>
      <FAQS/>
       <Footer/>
    </>
  )
}
export default AppDevelopment